var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-column list top start",staticStyle:{"background":"transparent"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/system/logo.png"}})])
}]

export { render, staticRenderFns }